import axios from "@/libs/api.request";
// 获取提单增长率
export const getCustomerServerBull = params => {
  return axios.request({
    url: "/statistics/getStatisticsExtract",
    method: "get",
    params
  });
};

// 获取转单超时
export const getCustomerServerOverTime = params => {
  return axios.request({
    url: "/statistics/getTransferTimeOut",
    method: "get",
    params
  });
};

// 获取转单超时订单号
export const getTransferTimeOutAwb = params => {
  return axios.request({
    url: "/statistics/getTransferTimeOutAwb",
    method: "get",
    params
  });
};
